import '../css/monthly.css';
import '../css/wa.css';
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IoTimeOutline, IoHeart, IoNotificationsOutline } from "react-icons/io5";
import { RiKakaoTalkFill } from "react-icons/ri";
import { FaCommentAlt, FaFireAlt, FaRegNewspaper,FaLink, FaEye, FaRegCalendar, FaRegClock, FaRegHeart, FaHeart, FaBookmark, FaRegListAlt, FaRegBookmark, FaRegCommentAlt } from "react-icons/fa";
import React, { useEffect, useState, useRef } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { publishComment } from '../api/postApi'; // Assume you'll create this API function

import SunEditor from 'suneditor-react';
import { useToast } from "../components/ToastProvider";

function Article() {
    const { id } = useParams(); // URL에서 id를 가져옴
    
    const likeCountRef = useRef(0); // 좋아요 수 초기값 98

    const bookmarked = useRef(false); // 좋아요 상태 초기값 false
    const [commentData, setCommentData] = useState(null); // 에러 상태
    const [repl, setRepl] = useState(null); // 에러 상태


    const [articleData, setArticleData] = useState(null); // 아티클 데이터를 저장할 상태
    const [commentCount, setCommentCount] = useState(0); // 아티클 데이터를 저장할 상태
    const [commentListData, setCommentListData] = useState(null); // 아티클 데이터를 저장할 상태
    const [writer, setWriter] = useState(null); // 아티클 데이터를 저장할 상태
    const [sortedComments, setSortedComments] = useState([]);
    const [sortType, setSortType] = useState('latest'); // 기본 최신순
    const [openReplyBox, setOpenReplyBox] = useState(null); // 열려 있는 답글 박스 ID 저장
    const [likeCount, setLikeCount] = useState(null); // 열려 있는 답글 박스 ID 저장

    const [editorData, setEditorData] = useState('');
    const [saved, setSaved] = useState(null); // 열려 있는 답글 박스 ID 저장
    const [liked, setLiked] = useState(false); // 열려 있는 답글 박스 ID 저장
    const [myId, setMyId] = useState(false); // 열려 있는 답글 박스 ID 저장

    const handleReplyToggle = (commentId) => {
        setOpenReplyBox(prevId => (prevId === commentId ? null : commentId));
    };

   

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                let response;
                response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/monthly/fetch`, { id });
                const data = response;
                console.log(data);
                setWriter(data);
                setArticleData(data.data);
                setCommentListData(data.data.comment);
    
                console.log('좋아요 데이터', data.liked);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("해당 게시글을 찾을 수 없습니다.");
                    window.history.back(); // 이전 페이지로 이동
                } else {
                    console.error("게시글 불러오기 오류:", error);
                }
            }
        };
    
        fetchArticle();
    }, [id]);
    


    
    const [scrollPercent, setScrollPercent] = useState(0); // 스크롤 퍼센트 상태

    useEffect(() => {
        const handleScroll = () => {
        const scrollTop = window.scrollY; // 현재 스크롤 위치
        const scrollHeight = document.documentElement.scrollHeight; // 전체 문서 높이
        const clientHeight = document.documentElement.clientHeight; // 화면 높이
        const scrolled = (scrollTop / (scrollHeight - clientHeight)) * 100; // 스크롤 퍼센트 계산
        setScrollPercent(scrolled); // 상태 업데이트
        };

        window.addEventListener("scroll", handleScroll); // 스크롤 이벤트 리스너 등록
        return () => window.removeEventListener("scroll", handleScroll); // 컴포넌트 언마운트 시 이벤트 제거
    }, []);
    
    useEffect(() => {
        if (!Array.isArray(commentListData)) return; // commentListData가 배열인지 확인
    
        const sorted = [...commentListData].sort((a, b) => {
            if (sortType === 'latest') {
                return new Date(b.date) - new Date(a.date);
            } else if (sortType === 'popular') {
                return b.like - a.like;
            }
        });
    
        setSortedComments(sorted);
    }, [commentListData, sortType]);
    


    const handleEditorChange = (content) => {
        setEditorData(content);
        setCommentData(content);
    };



    const handleCommentChange = (e) => {
        setCommentData(e.target.value); // state 업데이트
      };

    const handleReplChange = (content) => {
        setRepl(content); // state 업데이트
    };


    const handleComment = async () => {
        try {
            const data = {
                thisId: id,
                content: commentData,
                articleId: id,
                isRepl: false
            };
            const response = await publishComment(data);
            if (response && response.commentId) {
                setCommentData('');
                const token = localStorage.getItem("token");
                let response;
                if (token) {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
                } else {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
                }
                const data = response.data.comment;
                const commentCoun = data.length;
                setCommentCount(commentCoun);
                setCommentListData(data);
                //리프레쉬
            } else {
                alert('실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
        
            // Handle 401 Unauthorized response
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('오류가 발생했습니다.');
            }
        }
        
    };

    const handleRepl = async (replId) => {
        try {
            const data = {
                thisId: replId,
                content: repl,
                articleId: id,
                isRepl: true
            };
            const response = await publishComment(data);
            if (response && response.commentId) {
                setRepl('');
                const token = localStorage.getItem("token");
                let response;
                if (token) {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
                } else {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
                }
                const data = response.data.comment;
                const commentCoun = data.length;
                setCommentCount(commentCoun);
                setCommentListData(data);
                //리프레쉬
            } else {
                alert('실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
        
            // Handle 401 Unauthorized response
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('오류가 발생했습니다.');
            }
        }
        
    };

    const handleCommentLike = async (targetId) => {
        const token = localStorage.getItem("token");
    
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/community/like`,
                {
                    id: targetId,
                    target: "comment",
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const response2 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
            const data = response2.data.comment;
            const commentCoun = data.length;
            setCommentCount(commentCoun);
            setCommentListData(data);
        } catch (error) {
            console.error("Failed to like comment:", error);
    
            // 500 오류 발생 시 알림
            if (error.response && error.response.status === 500) {
                alert("로그인 후 반응할 수 있습니다.");
            }
        }
    };


    const toggleDelete = async (code, type) => {
        const token = localStorage.getItem("token");
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/delete`,
                {
                    token: token,
                    id: code,
                    type: type
                },
            );
            window.location.reload();
        } catch (error) {
            console.error("Failed to like comment:", error);
        }
    };
    
    
    

    return (
      <>
        <div className="at-progress-ct">
            <div className="at-progress-bar" style={{ width: `${scrollPercent}%` }}></div>
        </div>
        <div className='monthly-center'>
            <div>
                <div className='monthly-article'>
                    <div className='mt-header'>
                        <div className='mt-title'>
                            {articleData?.data.title}
                        </div>
                        <div className='mt-month'>{articleData?.month}월 월간지</div>

                    </div>
                    <div className="mt-content-html" dangerouslySetInnerHTML={{ __html: articleData?.data.content }} />
                </div>




                <div className='monthly-article' style={{padding:30}}>
                    <h3 style={{marginBottom:25,marginTop:0}}>감상평 남기기</h3>
                    <div className='at-comment-ct'>
                        <SunEditor
                            mode="inline"
                            onChange={handleEditorChange}
                            setContents={editorData}
                            placeholder="댓글 작성"
                            lang="ko"
                            setOptions={{
                                height: '400px',
                                maxHeight: '550px',
                                placeholder: '여기에 감상평을 입력해주세요...',
                                buttonList: [
                                    ['undo'],
                                    ['formatBlock'],
                                    ['bold', 'italic', 'underline', 'strike', 'fontColor', 'hiliteColor'],
                                    ['align', 'horizontalRule'],
                                    ['table', 'link', 'image'],
                                ],
                                font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',
                            }}
                        />
                        <div className='at-comment-bottom'>
                            <div className='at-comment-count'>0/400</div>
                            <button className='at-comment-submit' onClick={handleComment}>등록</button>

                        </div>
                    </div>
                    <div className="at-comment-select">
                        <button onClick={() => setSortType('latest')}>최신순</button>
                        <button onClick={() => setSortType('popular')}>인기순</button>
                    </div>
                    {sortedComments.map((comment) => (
                        <div key={comment.id} className='at-comment-box'>
                            {myId === comment.writer.id && (
                                <div className='at-comment-delete' onClick={() => toggleDelete(comment.id, 'comment')}>삭제하기</div>
                            )}
                        
                            <div className='at-comment-ct-header' onClick={() => window.location.href = `/profile/${comment.writer.id}`}>
                                <div className='at-comment-ct-profile wa-profile'>
                                    <img src={comment.writer.profile}></img>
                                </div>
                                <div className='at-comment-ct-name'>{comment.writer.username}</div>
                                <div className='at-comment-ct-info' style={{ marginLeft: '5px' }}>
                                    <FaRegClock /> {comment.date}
                                </div>  
                            </div>
                            <div className='at-comment-ct-content'
                                dangerouslySetInnerHTML={{ __html: comment.content }}
                            ></div>

                            <div className='at-comment-ct-info'>
                                {comment && comment.likedThis ? (
                                    <span onClick={() => handleCommentLike(comment.id)}>
                                        <FaHeart style={{ fill: 'red' }} /> 좋아요 {comment.like}
                                    </span>
                                ) : (
                                    <span onClick={() => handleCommentLike(comment.id)}>
                                        <FaRegHeart /> 좋아요 {comment.like}
                                    </span>
                                )}
                                <div onClick={() => handleReplyToggle(comment.id)} style={{ cursor: 'pointer' }}>
                            
                                    <FaRegCommentAlt /> 답글 달기
                                </div>
                            </div>

                            {comment.replyCount > 0 && (
                                <div className='at-comment-repl' onClick={() => handleReplyToggle(comment.id)}>
                                    <FaChevronDown />
                                    답글 {comment.replyCount}개
                                </div>
                            )}

                            <div className='at-comment-repl-box' style={{ display: openReplyBox === comment.id ? 'block' : 'none' }}>
                                <div className='at-repl-ct'>
                                    <SunEditor
                                        mode="inline"
                                        onChange={handleReplChange}
                                        setContents={repl}
                                        placeholder="댓글 작성"
                                        lang="ko"
                                        setOptions={{
                                            height: '400px',
                                            maxHeight: '550px',
                                            placeholder: '여기에 내용을 입력해주세요...',
                                            buttonList: [
                                                ['undo'],
                                                ['formatBlock'],
                                                ['bold', 'italic', 'underline', 'strike', 'fontColor', 'hiliteColor'],
                                                ['align', 'horizontalRule'],
                                                ['table', 'link', 'image'],
                                            ],
                                            font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                            fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                            defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',
                                        }}
                                    />
                                    <button className='at-comment-submit' onClick={() => handleRepl(comment.id)} style={{minWidth:80}}>등록</button>
                                </div>
                                {comment.reply.map((repl) => (
                                    <div key={repl.id} className='at-comment-box'>
                                        {myId === repl.writer.id && (
                                            <div className='at-comment-delete' onClick={() => toggleDelete(repl.id, 'comment')}>삭제하기</div>
                                        )}
                                        <div className='at-comment-ct-header' onClick={() => window.location.href = `/profile/${repl.writer.id}`}>
                                        <div className='at-comment-ct-profile wa-profile'>
                                            <img src={repl.writer.profile}></img>
                                        </div>
                                            <div className='at-comment-ct-name'>{repl.writer.username}</div>
                                            <div className='at-comment-ct-info' style={{ marginLeft: '5px' }}>
                                                <FaRegClock /> {repl.date}
                                            </div>  
                                        </div>
                                        <div className='at-comment-ct-content'
                                            dangerouslySetInnerHTML={{ __html: repl.content }}
                                        ></div>

                                        <div className='at-comment-ct-info'>
                                            {repl && repl.likedThis ? (
                                                <span onClick={() => handleCommentLike(repl.id)}>
                                                    <FaHeart style={{ fill: 'red' }} /> 좋아요 {repl.like}
                                                </span>
                                            ) : (
                                                <span onClick={() => handleCommentLike(repl.id)}>
                                                    <FaRegHeart /> 좋아요 {repl.like}
                                                </span>
                                            )}
                                            {/* <div onClick={() => handleReplToRepl(repl.writer.id)} style={{ cursor: 'pointer' }}>
                                                <FaRegCommentAlt /> 답글 달기
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>



                           
                        </div>
                    ))}
                </div>
            </div>
        </div>

        
      </>
    );
  }

export default Article;